import * as yup from 'yup'
import { PHONE_REGEX, URL_REGEX } from '../../constants/regex'

export const profileSchema = yup.object().shape({
  firstname: yup.string().required('forms.mandatory-field'),
  lastname: yup.string().required('forms.mandatory-field'),

  phone: yup
    .string()
    .nullable()
    .notRequired()
    .test(
      'is-valid-phone',
      'Invalid phone number',
      (value) => !value || PHONE_REGEX.test(value)
    ),

  website: yup
    .string()
    .nullable()
    .notRequired()
    .test(
      'is-valid-url',
      'Must be a valid URL',
      (value) => !value || URL_REGEX.test(value)
    ),

  title: yup.string().required('forms.mandatory-field'),
  company: yup.string().nullable(),

  country: yup.string().required('forms.mandatory-field'),

  state: yup.string().when('country', {
    is: (country) => country === 'CA' || country === 'US',
    then: () => yup.string().required('forms.mandatory-field'),
    otherwise: () => yup.string()
  }),

  city: yup.string(),
  language: yup.string().nullable()
})
